import { Box, BoxProps, useSlotRecipe } from '@chakra-ui/react'
import React from 'react'
import { TabContentProps } from './Tabs.interface'

interface Props extends BoxProps, TabContentProps {
  title: string
}

const TabContent = ({
  children,
  title,
  slug,
}: Props): React.ReactElement<React.PropsWithChildren> => {
  const recipe = useSlotRecipe({ key: 'customTabs' })
  const styles = recipe()

  return (
    <Box css={styles.tabContent} id={`${slug}-content`} aria-label={`${title} Content`}>
      {children}
    </Box>
  )
}

export default TabContent
